import { Controller } from "@hotwired/stimulus"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"

// Usage example on `app/views/users/edit.haml`:
//   #user_chat_connections.padded-tb{ data: {
//       controller: 'users--chat-connections-table',
//       'users--chat-connections-table-user-id-value': @user.id,
//     } }
//     %table#chat_connections_table{ data: {
//         'users--chat-connections-table-target': 'table'
//       } }
//
export default class extends Controller {
  static targets = ["table"]

  static values = {
    userId: String,
    chatConnectionsPath: String,
  }

  connect() {
    if (!this.hasTableTarget) return

    const $table = $(this.tableTarget)
    this.dataTable = createTurboDataTable($table, {
      serverSide: true,
      dom: 'rtp<"toolbar">i',
      pagingType: "full_numbers",
      order: [0, 0],
      footerCallback: () => {
        $("#check-all-connections").attr("checked", false)
      },
      ajax: {
        url: this.chatConnectionsPathValue || `${this.userIdValue}/chat_connections`,
      },
      columnDefs: [
        { targets: [0], sortable: false },
      ],
    })
  }

  disconnect() {
    if (this.dataTable) {
      this.dataTable = destroyTurboDataTable(this.dataTable)
    }
  }
}
